import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { AlertTriangleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 bg-trading-dark relative" data-id="element-173">
      <div className="container mx-auto px-4" data-id="element-174">
        <div className="max-w-4xl mx-auto" data-id="element-175">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-16" data-id="element-176">
            <div className="flex items-center gap-4 mb-6" data-id="element-177">
              <div className="w-12 h-1 bg-trading-red rounded-full" data-id="element-178"></div>
              <h2 className="text-3xl md:text-4xl font-heading text-white" data-id="element-179">
                La Cruda Realidad
              </h2>
            </div>

            <p className="text-xl text-slate-300 leading-relaxed mb-6 border-l-4 border-trading-gold pl-6 italic" data-id="element-180">
              Son las 10:45 AM. Acabas de recibir el correo que tanto temías:{' '}
              <span className="text-trading-red font-semibold" data-id="element-181">
                "Su cuenta ha sido incumplida por violar el límite de pérdida
                diaria"
              </span>
              . Estuviste a solo $200 de pasar, pero la volatilidad del NASDAQ
              te sacó en un "spike" y luego se fue a tu favor.
            </p>

            <p className="text-lg text-slate-400" data-id="element-182">
              La frustración es real. Sientes que el mercado sabe exactamente
              dónde está tu Stop Loss. Pero la verdad es más simple: no te falta
              una mejor gráfica, te falta un{' '}
              <strong className="text-white" data-id="element-183">Protocolo de Ejecución</strong>.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-184">
            <Card className="border-trading-red/20 bg-gradient-to-br from-trading-card to-trading-red/5" data-id="element-185">
              <div className="flex items-start gap-4" data-id="element-186">
                <div className="p-3 bg-trading-red/10 rounded-lg text-trading-red" data-id="element-187">
                  <AlertTriangleIcon className="w-6 h-6" data-id="element-188" />
                </div>
                <div data-id="element-189">
                  <h3 className="text-xl font-heading mb-3 text-white" data-id="element-190">
                    El Problema Real
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-191">
                    La mayoría de los traders fallan las pruebas de fondeo por
                    "sobre-exposición". Creen que estar 8 horas frente a la
                    pantalla les dará más dinero, cuando en realidad solo les da
                    más oportunidades para cometer errores emocionales.
                  </p>
                </div>
              </div>
            </Card>

            <Card className="border-trading-red/20 bg-gradient-to-br from-trading-card to-trading-red/5" delay={0.2} data-id="element-192">
              <div className="flex items-start gap-4" data-id="element-193">
                <div className="p-3 bg-trading-red/10 rounded-lg text-trading-red" data-id="element-194">
                  <AlertTriangleIcon className="w-6 h-6" data-id="element-195" />
                </div>
                <div data-id="element-196">
                  <h3 className="text-xl font-heading mb-3 text-white" data-id="element-197">
                    El NASDAQ no perdona
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed" data-id="element-198">
                    El NASDAQ es un animal salvaje. El 90% de los traders
                    minoristas entran en la apertura de NY por puro FOMO, sin
                    entender que las instituciones están usando sus órdenes como
                    "combustible" para mover el precio.
                  </p>
                </div>
              </div>
            </Card>
          </div>

          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} className="bg-trading-card/50 border border-white/5 rounded-2xl p-8" data-id="element-199">
            <h3 className="text-2xl font-heading text-center mb-8" data-id="element-200">
              Por qué lo que intentaste{' '}
              <span className="text-trading-red" data-id="element-201">NO funcionó</span>:
            </h3>

            <ul className="space-y-4" data-id="element-202">
              {['Los indicadores tradicionales como el RSI o MACD llegan tarde al movimiento explosivo del NASDAQ.', "Las estrategias de 'scalping' de todo el día te agotan mentalmente y te llevan a la 'operativa de venganza'.", 'Arriesgar el 2% por trade es una sentencia de muerte matemática para cualquier cuenta de fondeo con drawdown relativo.', 'Operar noticias sin un plan técnico es simplemente apostar en un casino con gráficos de velas.'].map((item, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-3" data-id="element-203">
                  <XCircleIcon className="w-6 h-6 text-trading-red flex-shrink-0 mt-0.5" data-id="element-204" />
                  <span className="text-slate-300" data-id="element-205">{item}</span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}